var $09e991522ca7e64e$exports = {};
"use strict";
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$fieldRows = document.querySelectorAll(".field-row");
const $09e991522ca7e64e$var$winner = document.getElementsByClassName("field-cell--2048");
let $09e991522ca7e64e$var$board;
let $09e991522ca7e64e$var$score = 0;
const $09e991522ca7e64e$var$rows = 4;
const $09e991522ca7e64e$var$columns = 4;
let $09e991522ca7e64e$var$tilesMoved = false;
window.onload = function() {
    $09e991522ca7e64e$var$setGame();
};
function $09e991522ca7e64e$var$setGame() {
    $09e991522ca7e64e$var$board = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    for(let r = 0; r < $09e991522ca7e64e$var$fieldRows.length; r++){
        const fieldRowCells = $09e991522ca7e64e$var$fieldRows[r].querySelectorAll(".field-cell");
        for(let c = 0; c < fieldRowCells.length; c++){
            fieldRowCells[c].id = `${r}-${c}`;
            const num = $09e991522ca7e64e$var$board[r][c];
            $09e991522ca7e64e$var$updateTile(fieldRowCells[c], num);
        }
    }
}
function $09e991522ca7e64e$var$hasEmptyTile() {
    for(let r = 0; r < $09e991522ca7e64e$var$rows; r++)for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
        if ($09e991522ca7e64e$var$board[r][c] === 0) return true;
    }
    return false;
}
function $09e991522ca7e64e$var$searchWinnerCell() {
    if ($09e991522ca7e64e$var$winner.length !== 0) $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
}
function $09e991522ca7e64e$var$setTwoTiles() {
    if (!$09e991522ca7e64e$var$hasEmptyTile()) return;
    let found = false;
    while(!found){
        const randomCellNumber = Math.random() <= 0.1 ? 4 : 2;
        const r = Math.floor(Math.random() * $09e991522ca7e64e$var$rows);
        const c = Math.floor(Math.random() * $09e991522ca7e64e$var$columns);
        if ($09e991522ca7e64e$var$board[r][c] === 0) {
            $09e991522ca7e64e$var$board[r][c] = randomCellNumber;
            const tile = document.getElementById(`${r}-${c}`);
            tile.innerText = `${randomCellNumber}`;
            tile.classList.add(`field-cell--${randomCellNumber}`);
            found = true;
        }
    }
}
function $09e991522ca7e64e$var$updateTile(tile, num) {
    tile.innerText = "";
    tile.classList.value = "field-cell";
    if (num > 0) {
        tile.innerText = num;
        tile.classList.add(`field-cell--${num}`);
    }
}
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    for(let r = 0; r < $09e991522ca7e64e$var$rows; r++){
        for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
            const tile = document.getElementById(`${r}-${c}`);
            tile.innerText = "";
            tile.classList.value = "field-cell";
            $09e991522ca7e64e$var$board[r][c] = 0;
        }
        $09e991522ca7e64e$var$score = 0;
        document.querySelector(".game-score").innerText = 0;
    }
    $09e991522ca7e64e$var$setTwoTiles();
    $09e991522ca7e64e$var$setTwoTiles();
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$button.classList.remove("start");
    $09e991522ca7e64e$var$button.classList.add("restart");
    $09e991522ca7e64e$var$button.innerText = "Restart";
});
document.addEventListener("keyup", (e)=>{
    if (e.code === "ArrowLeft") $09e991522ca7e64e$var$slideLeft();
    if (e.code === "ArrowRight") $09e991522ca7e64e$var$slideRight();
    if (e.code === "ArrowUp") $09e991522ca7e64e$var$slideUp();
    if (e.code === "ArrowDown") $09e991522ca7e64e$var$slideDown();
    if ($09e991522ca7e64e$var$tilesMoved) {
        $09e991522ca7e64e$var$setTwoTiles();
        $09e991522ca7e64e$var$searchWinnerCell();
        $09e991522ca7e64e$var$gameOver();
    }
    $09e991522ca7e64e$var$tilesMoved = false;
    document.querySelector(".game-score").innerText = $09e991522ca7e64e$var$score;
});
function $09e991522ca7e64e$var$filterZero(row) {
    return row.filter((num)=>num !== 0);
}
function $09e991522ca7e64e$var$slide(row) {
    let currentRow = row;
    currentRow = $09e991522ca7e64e$var$filterZero(currentRow);
    for(let i = 0; i < currentRow.length - 1; i++)if (currentRow[i] === currentRow[i + 1]) {
        currentRow[i] *= 2;
        currentRow[i + 1] = 0;
        $09e991522ca7e64e$var$score += currentRow[i];
    }
    currentRow = $09e991522ca7e64e$var$filterZero(currentRow);
    while(currentRow.length < $09e991522ca7e64e$var$columns)currentRow.push(0);
    return currentRow;
}
function $09e991522ca7e64e$var$canTilesSlide() {
    if ($09e991522ca7e64e$var$hasEmptyTile()) return true;
    for(let r = 0; r < $09e991522ca7e64e$var$rows; r++)for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
        const tile = $09e991522ca7e64e$var$board[r][c];
        if (c > 0 && tile === $09e991522ca7e64e$var$board[r][c - 1]) return true;
        if (c < $09e991522ca7e64e$var$columns - 1 && tile === $09e991522ca7e64e$var$board[r][c + 1]) return true;
        if (r > 0 && tile === $09e991522ca7e64e$var$board[r - 1][c]) return true;
        if (r < $09e991522ca7e64e$var$rows - 1 && tile === $09e991522ca7e64e$var$board[r + 1][c]) return true;
    }
    return false;
}
function $09e991522ca7e64e$var$gameOver() {
    if (!$09e991522ca7e64e$var$canTilesSlide()) $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
function $09e991522ca7e64e$var$arraysEqual(originalRow, row) {
    if (originalRow.length !== row.length) return false;
    for(let i = 0; i < originalRow.length; i++){
        if (originalRow[i] !== row[i]) return false;
    }
    return true;
}
function $09e991522ca7e64e$var$slideLeft() {
    for(let r = 0; r < $09e991522ca7e64e$var$rows; r++){
        let row = $09e991522ca7e64e$var$board[r];
        const originalRow = [
            ...row
        ];
        row = $09e991522ca7e64e$var$slide(row);
        $09e991522ca7e64e$var$board[r] = row;
        for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
            const tile = document.getElementById(`${r}-${c}`);
            const num = $09e991522ca7e64e$var$board[r][c];
            $09e991522ca7e64e$var$updateTile(tile, num);
        }
        if (!$09e991522ca7e64e$var$arraysEqual(originalRow, row)) $09e991522ca7e64e$var$tilesMoved = true;
    }
}
function $09e991522ca7e64e$var$slideRight() {
    for(let r = 0; r < $09e991522ca7e64e$var$rows; r++){
        let row = $09e991522ca7e64e$var$board[r];
        const originalRow = [
            ...row
        ];
        row.reverse();
        row = $09e991522ca7e64e$var$slide(row);
        row.reverse();
        $09e991522ca7e64e$var$board[r] = row;
        for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
            const tile = document.getElementById(`${r.toString()}-${c.toString()}`);
            const num = $09e991522ca7e64e$var$board[r][c];
            $09e991522ca7e64e$var$updateTile(tile, num);
        }
        if (!$09e991522ca7e64e$var$arraysEqual(originalRow, row)) $09e991522ca7e64e$var$tilesMoved = true;
    }
}
function $09e991522ca7e64e$var$slideUp() {
    for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
        let row = [
            $09e991522ca7e64e$var$board[0][c],
            $09e991522ca7e64e$var$board[1][c],
            $09e991522ca7e64e$var$board[2][c],
            $09e991522ca7e64e$var$board[3][c]
        ];
        const originalRow = [
            ...row
        ];
        row = $09e991522ca7e64e$var$slide(row);
        for(let r = 0; r < $09e991522ca7e64e$var$rows; r++){
            $09e991522ca7e64e$var$board[r][c] = row[r];
            const tile = document.getElementById(`${r.toString()}-${c.toString()}`);
            const num = $09e991522ca7e64e$var$board[r][c];
            $09e991522ca7e64e$var$updateTile(tile, num);
        }
        if (!$09e991522ca7e64e$var$arraysEqual(originalRow, row)) $09e991522ca7e64e$var$tilesMoved = true;
    }
}
function $09e991522ca7e64e$var$slideDown() {
    for(let c = 0; c < $09e991522ca7e64e$var$columns; c++){
        let row = [
            $09e991522ca7e64e$var$board[0][c],
            $09e991522ca7e64e$var$board[1][c],
            $09e991522ca7e64e$var$board[2][c],
            $09e991522ca7e64e$var$board[3][c]
        ];
        const originalRow = [
            ...row
        ];
        row.reverse();
        row = $09e991522ca7e64e$var$slide(row);
        row.reverse();
        for(let r = 0; r < $09e991522ca7e64e$var$rows; r++){
            $09e991522ca7e64e$var$board[r][c] = row[r];
            const tile = document.getElementById(`${r.toString()}-${c.toString()}`);
            const num = $09e991522ca7e64e$var$board[r][c];
            $09e991522ca7e64e$var$updateTile(tile, num);
        }
        if (!$09e991522ca7e64e$var$arraysEqual(originalRow, row)) $09e991522ca7e64e$var$tilesMoved = true;
    }
}


//# sourceMappingURL=index.389378a8.js.map
